import { render, staticRenderFns } from "./AddMemberInPickupGroups.vue?vue&type=template&id=3c973f06&scoped=true&"
import script from "./AddMemberInPickupGroups.vue?vue&type=script&lang=js&"
export * from "./AddMemberInPickupGroups.vue?vue&type=script&lang=js&"
import style0 from "./AddMemberInPickupGroups.vue?vue&type=style&index=0&id=3c973f06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c973f06",
  null
  
)

export default component.exports